if (!customElements.get("quick-add-drawer")) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector(".js-product-details");
      this.form = this.querySelector("product-form");
      this.notification = this.querySelector(".js-added-to-cart");
      document.addEventListener("click", this.handleDocumentClick.bind(this));
      this.addEventListener("on:variant:change", this.handleVariantChange.bind(this));
    }

    handleDocumentClick(event) {
      let quickAddBtn = event.target.closest(".js-quick-add");
      if (quickAddBtn) {
        this.open(quickAddBtn);
      }
    }

    handleVariantChange(event) {
      if (event.detail.variant) {
        let media = event.detail.variant.featured_media || null;
        if (media) this.updateMedia(media.id);
      }
      
      let url = this.productUrl;
      if (event.detail.variant) {
        let separator = this.productUrl.includes("?") ? "&" : "?";
        url += `${separator}variant=${event.detail.variant.id}`;
      }
      
      this.querySelectorAll(".js-prod-link").forEach((link) => {
        link.href = url;
      });
    }

    async open(button) {
      button.setAttribute("aria-disabled", "true");
      this.notification.hidden = true;

      if (this.productUrl && this.productUrl === button.dataset.productUrl) {
        if (button.dataset.selectedColor) this.setActiveVariant(button);
        super.open(button);
        button.removeAttribute("aria-disabled");
        return;
      }

      this.productUrl = button.dataset.productUrl;
      this.content.innerHTML = "";
      super.open(button);
      
      let response = await fetch(button.dataset.productUrl);
      if (response.ok) {
        let template = document.createElement("template");
        template.innerHTML = await response.text();
        this.productEl = template.content.querySelector(".cc-main-product .js-product");
        this.renderProduct(button);
      }
      button.removeAttribute("aria-disabled");
    }

    renderProduct(button) {
      let sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, "quickadd");

      let variantPicker = this.productEl.querySelector("variant-picker");
      if (variantPicker) variantPicker.dataset.updateUrl = "false";

      let sizeChart = this.productEl.querySelector("#size-chart");
      if (sizeChart) {
        this.productEl.querySelector('[data-modal="size-chart"]').remove();
        sizeChart.remove();
      }

      this.updateForm();
      this.updateContent();

      let mediaUpdated = false;
      if (button.dataset.selectedColor) {
        this.setActiveVariant(button);
        if (this.currentMediaId) mediaUpdated = true;
      }

      if (!mediaUpdated) {
        let activeMedia = this.productEl.querySelector(".media-viewer__item.is-active");
        if (activeMedia) this.updateMedia(Number(activeMedia.dataset.mediaId));
      }
    }

    setActiveVariant(button) {
      this.querySelectorAll(".option-selector").forEach((selector) => {
        let optionBtn = selector.querySelector(`.opt-btn[value="${button.dataset.selectedColor}"]`);
        if (optionBtn) {
          optionBtn.click();
          return;
        }
        let firstAvailable = selector.querySelector(".opt-btn:not(.is-unavailable)");
        if (firstAvailable && !firstAvailable.checked) firstAvailable.click();
      });
    }

    updateMedia(mediaId) {
      if (this.currentMediaId === mediaId) return;
      this.currentMediaId = mediaId;

      let mediaImage = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!mediaImage) return;
      
      let src = mediaImage.src ? mediaImage.src.split("&width=")[0] : mediaImage.dataset.src.split("&width=")[0];
      let mediaContainer = this.querySelector(".quick-add-info__media");
      let width = mediaContainer.offsetWidth;
      let aspectRatio = mediaImage.width / mediaImage.height;
      
      mediaContainer.innerHTML = `
        <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${2 * width} 2x" width="${2 * width}" height="${(2 * width) / aspectRatio}" alt="${mediaImage.alt}">
      `;
    }

    updateContent() {
      this.content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media"></div>
          <div class="quick-add-info__details">
            <div class="product-vendor-sku mb-2 text-sm">${this.getElementHtml(".product-vendor-sku")}</div>
            <div class="product-title mb-2">
              <a class="h5 js-prod-link" href="${this.productUrl}">${this.getElementHtml(".product-title")}</a>
            </div>
            <div class="product-price js-product-price">${this.getElementHtml(".product-info__price")}</div>
            <div class="mt-4">
              <a href="${this.productUrl}" class="feature-link feature-link--light js-prod-link">${theme.strings.viewDetails}</a>
            </div>
          </div>
        </div>
        <div class="product-options">${this.getElementHtml(".product-options", ".custom-option")}</div>
      `;
    }

    updateForm() {
      let formElement = this.productEl.querySelector("product-form");
      if (formElement) {
        this.form.innerHTML = formElement.innerHTML;
        QuickAddDrawer.restoreScripts(this.form);
        this.form.init();
        if (Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      } else {
        this.form.innerHTML = "";
      }
    }

    getElementHtml(selector, ...extraSelectors) {
      let selectors = [selector, ...extraSelectors];
      return selectors.map((sel) => Array.from(this.productEl.querySelectorAll(sel)).map(el => el.innerHTML).join(""))
                      .join("");
    }

    addedToCart() {
      this.notification.hidden = false;
    }

    static restoreScripts(element) {
      Array.from(element.querySelectorAll("script")).forEach((script) => {
        let newScript = document.createElement("script");
        Array.from(script.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = script.textContent;
        script.parentNode.replaceChild(newScript, script);
      });
    }
  }
  customElements.define("quick-add-drawer", QuickAddDrawer);
}
